<template>
<div>
    <div class="kit__utils__heading">
      <h5><span class="mr-3">{{groupName}} -> {{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0"></h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">Created New</a>
        </div>
      </div>
      <div class="card-body">
        <div class="col-12">
          <table class="table table-striped">
            <thead class="thead-gray">
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col">icon</th>
                <th scope="col">menuKey</th>
                <th scope="col">route</th>
                <th scope="col">status</th>
                <th scope="col">createdAt</th>
                <th scope="col">Manage</th>
              </tr>
            </thead>
            <draggable v-model="data" tag="tbody" @change="rownumber(data)">
              <tr v-for="item in data" :key="item.name">
                <td scope="row">{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.icon }}</td>
                <td>{{ item.menuKey }}</td>
                <td>{{ item.route }}</td>
                <td>
                  <b-badge :variant="getStatus(item.status).color" pill >
                    {{(item.status)?'Active':'Block'}}
                  </b-badge>
                </td>
                <td>{{ date(item.createdAt) }}</td>
                <td>
                  <a href="#" class="Manager" title="Edit" @click="showModal('update',item.id)"><i
                      class="fe fe-settings"></i></a>
                <a-popconfirm
                  title="Do you want to update these items?"
                  ok-text="Yes"
                  cancel-text="No"
                  @confirm="block(item)"
                  @cancel="cancel"
                ><a href="#" class="Manager" :title="getStatus(item.status).title" ><i :class="getStatus(item.status).icon"></i></a></a-popconfirm>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
     <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
      @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
        <div class="row">
          <div class="col-md-12">
            <a-form-model-item label="name" prop="name">
              <a-input v-model="form.name" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="icon" prop="icon">
              <a-input v-model="form.icon" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="menuKey" prop="menuKey">
              <a-input v-model="form.menuKey" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="route" prop="route">
              <a-input v-model="form.route" />
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import apiClient from '@/services/api'
import useNoti from '@/services/plugin/notification'
// import { Modal } from 'ant-design-vue'
import moment from 'moment'

import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  components: {
    draggable,
  },
  data() {
    return {
      data: [],
      drag: false,
      visible: false,
      form: {
        id: '',
        name: '',
        icon: '',
        menuKey: '',
        route: '',
        groupMenuOperatorId: '',
        status: true,
      },
      rules: {
        name: [
          { required: true, message: 'กรุณากรอกชื่อ', trigger: 'blur' },
        ],
        icon: [
          { required: true, message: 'กรุณากรอกไอคอน', trigger: 'blur' },
        ],
        route: [
          { required: true, message: 'กรุณากรอก route', trigger: 'blur' },
        ],
        menuKey: [
          { required: true, message: 'กรุณากรอก menuKey', trigger: 'blur' },
        ],
      },
      groupName: '',
    }
  },

  methods: {
    clearForm() {
      this.form = {
        name: '',
        icon: '',
        route: '',
        menuKey: '',
      }
    },
    showModal(type, id = null) {
      // get OpertorCode
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มข้อมูลเมนู' : 'แก้ไขข้อมูลเมนู'
      if (type === 'update') {
        this.getDataMenuUpdate(id)
      } else {
        this.form.groupMenuOperatorId = this.$route.params.id
        this.visible = !this.visible
      }
    },
    getDataMenuUpdate(id) {
      apiClient.get(`/manageMenuOperator/menuOperator/${id}`).then(res => {
        if (res.data.code === '000') {
          const dataManu = res.data.responseData.data[0]
          this.form.MenuId = dataManu.id
          this.form.groupMenuOperatorId = this.$route.params.id
          this.form.name = dataManu.name
          this.form.icon = dataManu.icon
          this.form.menuKey = dataManu.menuKey
          this.form.route = dataManu.route
          this.form.status = dataManu.status
          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async getDataMenu() {
      await apiClient.get(`/manageMenuOperator/menu/${this.$route.params.id}`).then(response => {
        const res = response.data

        if (res.code === '000') {
          this.data = res.responseData.data
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    async getGroupMenu() {
      await apiClient.get(`/manageMenuOperator/groupMenu/${this.$route.params.id}`, {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const DataGroupMenu = res.responseData.data[0]
          this.groupName = DataGroupMenu.name
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // ส่งข้อมูลอัปเดทสถานะ
                // console.log(this.form);
                if (this.form.type === 'update') {
                  return apiClient.put(`manageMenuOperator/updateMenu/${this.form.MenuId}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error.message}`,
                    )
                  })
                } else {
                  return apiClient.post('manageMenuOperator/insertMenu', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error.message}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.confirmLoading = false
              this.getDataMenu()
            }
          })
        }
      })
    },
    handleOk(e) {
      this.onSubmit()
    },

    date: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    handleCancel(e) {
      this.visible = false
    },
    getStatus(status) {
      const success = [
        {
          title: 'บล็อค',
          code: 0,
          name: 'ใช้งานปกติ',
          color: 'success',
          icon: 'fe fe-lock',
        }]
      const danger = [
        {
          title: 'ปลดบล็อค',
          code: 1,
          name: 'บล็อคการใช้งาน',
          color: 'danger',
          icon: 'fe fe-unlock',
        },
      ]
      return status === true ? success[0] : danger[0]
    },
    block(result) {
      const sentData = {
        name: result.name,
        icon: result.icon,
        route: result.route,
        menuKey: result.menuKey,
        status: !result.status,
        groupMenuOperatorId: result.groupMenuOperatorId,
      }
      // Modal.confirm({
      //   title: 'Confirm',
      //   content: 'Do you want to update these items?',
      //   okText: 'Yes',
      //   okType: 'danger',
      //   cancelText: 'No',
      //   onOk: () => {
      apiClient.put(`/manageMenuOperator/updateStatusOperatorMenu/${result.id}`, sentData).then(response => {
        if (response.data.code === '000') {
          this.getDataMenu()
          useNoti('success', 'Success', response.data.message)
          this.visible = false
        } else {
          this.getDataMenu()
          // this.setErrorForm(response.data.responseData, response.data.message)
          useNoti('error', 'Error', response.data.message)
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
      //     },
      //     onCancel() {

    //     },
    //   })
    },
    cancel() {
      this.$message.error('Click on No')
    },
    rownumber(data) {
      if (data) {
        return apiClient.post('/manageMenuOperator/sortNumMenu', data).then(response => {
          if (response.status === 200) {
            useNoti('success', 'Success', response.data.message)
          } else {
            useNoti('error', 'Error', response.data.message)
          }
        }).catch(err => {
          useNoti('error', 'Error', err.message)
        })
      }
    },
  },
  async created() {
    await this.getDataMenu()
    await this.getGroupMenu()
  },
}
</script>
<style>
.Manager {
  font-size: 20px;
  bottom: calc(8% + 60px);
  padding: 3px;
  border-radius: 10%;
}
</style>
